import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { CarouselModule } from 'primeng/carousel';

import { Dynamic } from '@shared/registry/dynamic';

import type { CarouselConfig } from './carousel.types';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CarouselModule, Dynamic],
})
export class Carousel {
  readonly config = input.required<CarouselConfig>();

  protected readonly images = computed(() => this.config().images);
  protected readonly height = computed(() => this.config().height ?? '320px');
  protected readonly showIndicators = computed(() => this.config().showIndicators ?? true);
  protected readonly showNavigators = computed(() => this.config().showNavigators ?? false);
  protected readonly circular = computed(() => this.config().circular ?? true);

  protected readonly imageStyle = computed(() => ({
    height: this.height(),
  }));
}
